import { createElement as rc } from 'react';
import PropTypes from 'prop-types';
import styled from '../styled';
import webOnlyStyles from '../webOnlyStyles';
import fromTheme from '../fromTheme';
import Text from './Text';
import ThemeComponentSwitcher from '../styling/ThemeComponentSwitcher';

import gl2025Tooltip from './Tooltip.gl2025';
import { useTheme } from 'styled-components';

let _Tooltip = styled(Text).attrs({ children: 'i', name: 'Tooltip' })`
    background-color: ${fromTheme('colorScheme', 'primary')};
    visibility: ${props => (props.theme.mobile ? 'hidden' : 'visible')};
    position: relative;
    display: inline-block;
    margin-left: 5px;
    border-radius: 50%;
    font-size: 12px;
    padding: 2px 2px 1px 2px;
    color: white;
    width: 18px;
    height: 18px;
    text-align: center;
    font-weight: bold;
`;

_Tooltip = webOnlyStyles(_Tooltip)`
    cursor: help;
`;
_Tooltip.displayName = 'Tooltip';

/** Generate an info "i" icon to indicate a tooltip is available
 * and to show the tooltip on hover via the title attribute
 * Hidden on mobile view ports
 */
function Tooltip(props) {
    const { mobile } = useTheme();
    if (mobile || !props.title) {
        return null;
    }
    return rc(_Tooltip, props);
}

Tooltip.propTypes = {
    title: PropTypes.string
};

let SwitchedComponent = ThemeComponentSwitcher([
    {
        theme: 'gl2025',
        component: gl2025Tooltip
    },
    { component: Tooltip }
]);

SwitchedComponent.Popup = gl2025Tooltip.Popup;

export default SwitchedComponent;
